import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { useLang } from "@/contexts/LangContext";

export default function Register() {
  const { t } = useLang();
  const { register } = useAuth();
  const nav = useNavigate();
  const [params] = useSearchParams();
  const [form, setForm] = useState({ name: "", email: "", password: "", role: params.get("role") || "client" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await register(form);
      const path =
        u.role === "admin" || u.role === "moderator"
          ? "/admin/dashboard"
          : u.role === "agency"
          ? "/dashboard/agency"
          : u.role === "independent"
          ? "/dashboard/independent"
          : "/dashboard/client";
      nav(path);
    } catch (e) { console.warn("[Register.jsx] non-blocking error:", e); } finally { setBusy(false); }
  };

  return (
    <div className="min-h-[80vh] max-w-md mx-auto px-4 py-16" data-testid="register-page">
      <p className="text-overline">Relaxora</p>
      <h1 className="font-heading text-4xl text-white mt-2 mb-8 font-light">{t.auth.register}</h1>
      <form onSubmit={submit} className="space-y-4">
        <input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder={t.auth.name} required className="w-full bg-[#121212] border border-white/10 rounded-md px-4 py-3 text-white focus:border-gold/50 focus:outline-none" data-testid="register-name" />
        <input value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} type="email" placeholder={t.auth.email} required className="w-full bg-[#121212] border border-white/10 rounded-md px-4 py-3 text-white focus:border-gold/50 focus:outline-none" data-testid="register-email" />
        <input value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} type="password" placeholder={`${t.auth.passwordLabel} (min 6)`} required minLength={6} className="w-full bg-[#121212] border border-white/10 rounded-md px-4 py-3 text-white focus:border-gold/50 focus:outline-none" data-testid="register-password" />
        <div>
          <p className="text-overline mb-2">{t.auth.role}</p>
          <div className="grid grid-cols-3 gap-2">
            {[{ k: "client", l: t.auth.role_client }, { k: "independent", l: t.auth.role_independent }, { k: "agency", l: t.auth.role_agency }].map((o) => (
              <button key={o.k} type="button" onClick={() => setForm({ ...form, role: o.k })} className={`py-3 px-2 rounded-md text-xs border transition-all ${form.role === o.k ? "bg-gold/10 border-gold text-gold" : "border-white/10 text-[#a3a3a3]"}`} data-testid={`register-role-${o.k}`}>{o.l}</button>
            ))}
          </div>
        </div>
        <button disabled={busy} className="btn-gold rounded-md px-6 py-3 text-sm w-full disabled:opacity-50" data-testid="register-submit">{busy ? "…" : t.auth.register}</button>
      </form>
      <p className="text-sm text-[#a3a3a3] mt-6 text-center">
        {t.auth.have_account} <Link to="/login" className="text-gold">{t.auth.login}</Link>
      </p>
    </div>
  );
}
